<template>
  <tile>
    <h3>{{ $t('billing.success.confirmation.experience_with_zoom') }}</h3>
    <div class='opc-succezz__feedback'>
      <a data-testid="checkout-a-473" class='opc-succezz__feedback-cta' role='button' href="javascript:void(0);">
        <zm-icon><downvote-fill/></zm-icon>
        {{ $t('billing.success.confirmation.negative') }}
      </a>
      <a data-testid="checkout-a-474" class='opc-succezz__feedback-cta' role='button' href="javascript:void(0);">
        <zm-icon><upvote-fill/></zm-icon>
        {{ $t('billing.success.confirmation.positive') }}
      </a>
    </div>
  </tile>
</template>

<script>
import Tile from '@/components/tile.vue';
import { UpvoteFill, DownvoteFill } from '@zoom/icons-vue'

export default {
  components: {
    Tile,
    UpvoteFill,
    DownvoteFill,
  },
};
</script>

<style lang='scss'>
.opc-succezz {
  &__feedback {
    display: flex;
    height: 30px;
    margin-top: 10px;

    &-cta {
      display: flex;
      align-items: center;
      color: #0C5CFF;
      margin-right: 40px;
      .zbo-icons {
        color: #0C5CFF;
        margin-right: 8px;
      }
    }
  }
}
</style>
